/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/

import React, { ReactElement, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BrowserRestrictions } from '../../../types/restrictions';
import { Browsers } from '../../../utils/constants';
import { Namespaces } from '../../../utils/i18n';

type Props = {
	className?: string;
	browsers: BrowserRestrictions[];
};

const defaultProps = {
	className: '',
};

const RestrictionCardDesktop = ({ className, browsers }: Props): ReactElement => {
	const { t } = useTranslation(Namespaces.Common);

	const browserName = useCallback(
		(name: string) => {
			switch (name) {
				case Browsers.Chrome:
					return t('browsers.chrome');
				case Browsers.Firefox:
					return t('browsers.firefox');
				case Browsers.Safari:
					return t('browsers.safari');
				case Browsers.Edge:
					return t('browsers.edge');
				case 'internetexplorer11':
					return `${t('browsers.internetExplorer')} 11`;
				case 'internetexplorer10':
					return `${t('browsers.internetExplorer')} 10`;
				case 'internetexplorer9':
					return `${t('browsers.internetExplorer')} 9`;
				case 'internetexplorer8':
					return `${t('browsers.internetExplorer')} 8`;
				case 'internetexplorer7':
					return `${t('browsers.internetExplorer')} 7`;
				case 'internetexplorer6':
					return `${t('browsers.internetExplorer')} 6`;
				default:
					return name;
			}
		},
		[t]
	);

	return (
		<div className={className}>
			<h5 className="device-name">{t('restrictions.devices.desktop.title')}</h5>
			<ul className="os-browser-versions">
				{browsers.map(({ name, minVersion, excludedVersions }) => (
					<li key={`browser-${name}`}>
						<span>
							<span>{browserName(name)}</span> {minVersion === '' ? null : `${minVersion}+`}
						</span>
						<span>
							{excludedVersions?.length ? (
								<span>
									{' '}
									{t('restrictions.except')} {excludedVersions.join(', ')}
								</span>
							) : null}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
};

RestrictionCardDesktop.defaultProps = defaultProps;

export default RestrictionCardDesktop;
